import { useCallback } from "react";
import { MessagesService } from "../../../../../services/messages";
import { ISelectedConversation } from "../../../types/SelectedConversation";
import { updateReadConv } from "./updateReadConv";

export const useReadConversation = (
  setData: React.Dispatch<React.SetStateAction<any[]>>,
  setConversation: React.Dispatch<
    React.SetStateAction<ISelectedConversation | null>
  >
) => {
  const readConversation = useCallback(
    async (
      contractNumber: number,
      selectedConvValues: ISelectedConversation
    ) => {
      try {
        setConversation(selectedConvValues);

        await MessagesService.read(selectedConvValues.id);

        setData((prev) => {
          const newValues: any[] = structuredClone(prev);

          const groupIndex = prev.findIndex(
            (item: any) => item.contractNumber === contractNumber
          );

          if (groupIndex > -1) {
            const convIndex = prev[groupIndex].conversations.findIndex(
              (conv: any) => conv.id === selectedConvValues.id
            );

            convIndex > -1 && updateReadConv(newValues, groupIndex, convIndex);
          }

          return newValues;
        });
      } catch {}
    },
    [setData, setConversation]
  );

  return { readConversation };
};
